<template>
  <div class="live">
    <div class="main-contain">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Live",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile() {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
      this.isMobile = navigator.userAgent.match(regBrowser) ? true : false; // 判断是否是手机浏览
      return this.isMobile;
    },
  },
};
</script>
<style scoped lang="scss">
.live {
  .main-contain {
    width: 100%;
  }
}
</style>